import React from 'react';
import { motion } from 'framer-motion';
import './RACLegal.css';

const RACLegal = () => {
  console.log('[RACLegal] Component rendered');
  
  return (
    <section className="rac-legal">
      <div className="rac-legal-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-legal-content"
        >
          <h3 className="rac-legal-title">Legal / Risk Disclosure</h3>
          <p className="rac-legal-text">
            The RAC Program is an asset purchase plus bilateral hire-back arrangement. Hire rent is contractual and calculated based on Active Lease Days; monthly hire rent payouts are prorated accordingly and may reduce during planned dry periods (up to the 60-day Contract Year cap) and may pause during death, vet-certified unfit/non-performing, or replacement processing (including onboarding). Dry days beyond the 60-day Contract Year cap are treated as suspension days and trigger per-animal extension as defined in the hire-back agreement. Replacement timing: within 30 working days (excluding Saturdays, Sundays, and declared government holidays) from the date of death or the date of vet certification of unfit/non-performing (whichever applies). Hire rent depends on the hire-back agreement terms and PharmWealth's performance and ability to pay (counterparty risk). If a monthly hire rent payout is delayed, there is a 30-day cure period; during the cure period, the hire-back agreement remains in force and arrears are payable. If not cured, the owner may terminate and initiate buyback/settlement as per the hire-back agreement. Insurance coverage applies as per policy terms/exclusions and claim acceptance. Policyholder is the owner; beneficiary is PharmWealth. Calves and production benefits belong to PharmWealth. Buyback at full contract value (as defined in the hire-back agreement) is available only after the 2-year lock-in and is subject to hire-back agreement conditions and completion of documentation/transfer/novation steps; outstanding dues/adjustments (if any) may be netted off. Participants should review all documents and seek independent legal and tax advice.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default RACLegal;


